import { downloadPdf, PdfDownloadError, requestPdfDownload } from "./pdfDownload";

export { PdfDownloadError as PackingSlipApiError };

export const getPackingSlipPdf = (shipmentId: string) =>
  requestPdfDownload(
    `printShipping/${shipmentId}`,
    `packing-slip-${shipmentId}.pdf`,
    "Could not generate the packing slip PDF."
  );

export const downloadPackingSlipPdf = downloadPdf;
